module.exports = require('./../dist/svg-components/fontawesome/Bookmark');